// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-612fcaac\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/dist/cjs.js!./Sugerencias.scss");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = require("!../../../../node_modules/vue-style-loader/lib/addStylesClient.js")("2dab0f8b", content, true, {});


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-style-loader!./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-612fcaac","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js!./src/components/Chatbox/Sugerencias/Sugerencias.scss
// module id = 917
// module chunks = 0